import { BaseParameterTypes, DefaultMnemonic, WellStatuses } from './api/types';

export const statusesSortStructure = [
  WellStatuses.ACTIVE_GREEN,
  WellStatuses.ACTIVE_YELLOW,
  WellStatuses.ACTIVE_RED,
  WellStatuses.COMPLETED,
  WellStatuses.BAD,
];

export const timeSortedParameters = [
  BaseParameterTypes.AUTO_RECOGNIZED_EVENTS,
  BaseParameterTypes.AUTO_RECOGNIZED_OPERATIONS,
  BaseParameterTypes.DEPTH_HOLE,
  BaseParameterTypes.DEPTH_BIT,
  BaseParameterTypes.BLOCK_POSITION,
  BaseParameterTypes.HOOKLOAD,
  BaseParameterTypes.WEIGHT_ON_BIT,
  BaseParameterTypes.BIT_CONTACT_PRESSURE,
  BaseParameterTypes.ROTARY_SPEED,
  BaseParameterTypes.BIT_SPEED,
  BaseParameterTypes.ROTARY_TORQUE,
  BaseParameterTypes.MUD_FLOW_IN,
  BaseParameterTypes.STANDPIPE_PRESSURE,
  BaseParameterTypes.RATE_OF_PENETRATION,
  BaseParameterTypes.MECH_SPEC_ENERGY_SURFACE,
  BaseParameterTypes.MECH_SPEC_ENERGY_BIT,
  BaseParameterTypes.MAGNETIC_TOOLFACE,
  BaseParameterTypes.GRAVITY_TOOLFACE,
];

export const depthSortedParameters = [
  BaseParameterTypes.BLOCK_POSITION,
  BaseParameterTypes.HOOKLOAD,
  BaseParameterTypes.WEIGHT_ON_BIT,
  BaseParameterTypes.BIT_CONTACT_PRESSURE,
  BaseParameterTypes.ROTARY_SPEED,
  BaseParameterTypes.BIT_SPEED,
  BaseParameterTypes.ROTARY_TORQUE,
  BaseParameterTypes.MUD_FLOW_IN,
  BaseParameterTypes.STANDPIPE_PRESSURE,
  BaseParameterTypes.RATE_OF_PENETRATION,
  BaseParameterTypes.MECH_SPEC_ENERGY_SURFACE,
  BaseParameterTypes.MECH_SPEC_ENERGY_BIT,
  BaseParameterTypes.MAGNETIC_TOOLFACE,
  BaseParameterTypes.GRAVITY_TOOLFACE,
];

export const PARAMS_GRID_TITLES = ['parameter', 'company', 'log', 'mnemonic'];

export const nameDictionary: Record<BaseParameterTypes, string> = {
  [BaseParameterTypes.DEPTH_HOLE]: 'holeDepth',
  [BaseParameterTypes.AUTO_RECOGNIZED_OPERATIONS]: 'operation',
  [BaseParameterTypes.DEPTH_BIT]: 'bitDepth',
  [BaseParameterTypes.AUTO_RECOGNIZED_EVENTS]: 'event',
  [BaseParameterTypes.HOOKLOAD]: 'hookload',
  [BaseParameterTypes.STANDPIPE_PRESSURE]: 'standpipePressure',
  [BaseParameterTypes.ROTARY_TORQUE]: 'rotaryTorque',
  [BaseParameterTypes.BLOCK_POSITION]: 'blockPosition',
  [BaseParameterTypes.MUD_FLOW_IN]: 'mudFlowIn',
  [BaseParameterTypes.ROTARY_SPEED]: 'rotarySpeed',
  [BaseParameterTypes.WEIGHT_ON_BIT]: 'weightOnBit',
  [BaseParameterTypes.RATE_OF_PENETRATION]: 'penetrationRate',
  [BaseParameterTypes.GRAVITY_TOOLFACE]: 'gravityToolface',
  [BaseParameterTypes.MAGNETIC_TOOLFACE]: 'magneticToolface',
  [BaseParameterTypes.BIT_CONTACT_PRESSURE]: 'bitContactPressure',
  [BaseParameterTypes.MECH_SPEC_ENERGY_SURFACE]: 'mechSpecEnergySurface',
  [BaseParameterTypes.MECH_SPEC_ENERGY_BIT]: 'mechSpecEnergyBit',
  [BaseParameterTypes.BIT_SPEED]: 'bitSpeed',
};

export const defaultMnemonicDictionary: Record<BaseParameterTypes, DefaultMnemonic> = {
  [BaseParameterTypes.DEPTH_HOLE]: DefaultMnemonic.DEPTH_HOLE,
  [BaseParameterTypes.AUTO_RECOGNIZED_OPERATIONS]: DefaultMnemonic.AUTO_RECOGNIZED_OPERATIONS,
  [BaseParameterTypes.DEPTH_BIT]: DefaultMnemonic.DEPTH_BIT,
  [BaseParameterTypes.AUTO_RECOGNIZED_EVENTS]: DefaultMnemonic.AUTO_RECOGNIZED_EVENTS,
  [BaseParameterTypes.HOOKLOAD]: DefaultMnemonic.HOOKLOAD,
  [BaseParameterTypes.STANDPIPE_PRESSURE]: DefaultMnemonic.STANDPIPE_PRESSURE,
  [BaseParameterTypes.ROTARY_TORQUE]: DefaultMnemonic.ROTARY_TORQUE,
  [BaseParameterTypes.BLOCK_POSITION]: DefaultMnemonic.BLOCK_POSITION,
  [BaseParameterTypes.MUD_FLOW_IN]: DefaultMnemonic.MUD_FLOW_IN,
  [BaseParameterTypes.ROTARY_SPEED]: DefaultMnemonic.ROTARY_SPEED,
  [BaseParameterTypes.WEIGHT_ON_BIT]: DefaultMnemonic.WEIGHT_ON_BIT,
  [BaseParameterTypes.RATE_OF_PENETRATION]: DefaultMnemonic.RATE_OF_PENETRATION,
  [BaseParameterTypes.GRAVITY_TOOLFACE]: DefaultMnemonic.GRAVITY_TOOLFACE,
  [BaseParameterTypes.MAGNETIC_TOOLFACE]: DefaultMnemonic.MAGNETIC_TOOLFACE,
  [BaseParameterTypes.BIT_CONTACT_PRESSURE]: DefaultMnemonic.BIT_CONTACT_PRESSURE,
  [BaseParameterTypes.MECH_SPEC_ENERGY_SURFACE]: DefaultMnemonic.MECH_SPEC_ENERGY_SURFACE,
  [BaseParameterTypes.MECH_SPEC_ENERGY_BIT]: DefaultMnemonic.MECH_SPEC_ENERGY_BIT,
  [BaseParameterTypes.BIT_SPEED]: DefaultMnemonic.BIT_SPEED,
};
